export default {
	namespaced: true,
	state: () => ({
		centerIndex: 0,
		isNextPage: true, // 是否下一页
		lotteryModalShow: false,
		pageLotteryStart: false,
		musicInfo: {}
	}),
	mutations: {
		setCenterIndex(state, data) {
			state.centerIndex = data;
		},
		setIsNextPage(state, data) {
			state.isNextPage = data;
		},
		setLotteryModalShow(state, data) {
			state.lotteryModalShow = data;
		},
		setPageLotteryStart(state, data) {
			state.pageLotteryStart = data;
		},
		setMusicInfo(state, data) {
			state.musicInfo = data;
		},
	},
	actions: {},
	getters: {
		centerIndex(state) {
			return state.centerIndex;
		},
		isNextPage(state) {
			return state.isNextPage;
		},
		lotteryModalShow(state) {
			return state.lotteryModalShow;
		},
		pageLotteryStart(state) {
			return state.pageLotteryStart;
		},
		musicInfo(state) {
			return state.musicInfo;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/Activity/modules/report-listen.js